import React, { useEffect, useState } from "react";
import useIntersect from "./util/useIntersect";
import { KeyboardArrowUp } from "@mui/icons-material";
import { motion } from "motion/react";

function About() {
  const [q, setQ] = useState(null);

  const [ref, entry] = useIntersect({
    threshold: 0,
    rootMargin: "-50% 0% -50% 0%",
  });
  useEffect(() => {
    if (entry.isIntersecting) {
      if (entry.isIntersecting) {
        document.querySelectorAll(".nav-link").forEach((i) => {
          i.classList.remove("active");
        });
        document.getElementById("nav-about").classList.add("active");
        // setPosition1("services");
        // document.getElementById("service-title").classList.add("show-line");
      }
    }
    // eslint-disable-next-line
  }, [entry.isIntersecting]);
  return (
    <div className="about pt-4 mb-[-3rem]" id="about" ref={ref}>
      <h2 className="about-section-title">
        Saharawinds:{" "}
        <span className="orange">Logistics Excellence</span>
      </h2>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-5 mt-10">
        <div className="about-image rounded-md  rounded-t-3xl  h-[15rem] block lg:hidden"></div>

        <p className="about-s1">
          <b>
            Saharawinds Ltd, was established in 2018 as freight forwarding and
            customs agent company in Kenya. Saharawinds quickly gained
            recognition for the quality of its services in the logistics
            industry in Kenya. In recent years Saharawinds has become a leading
            logistics company specializing in:
          </b>
          <br />
          <br /> <b>International Freight Forwarding:</b> Efficiently managing
          end-to-end transportation of goods across international marketplace.{" "}
          <br />
          <br />
          <b>Customs Brokerage:</b> We adhere to industry protocols like AGOA,
          COMESA, and EU agreements, along with specific certifications such as
          phytosanitary and port health requirements, ensuring compliance and
          peace of mind.
          <br />
          <br /> <b>Comprehensive Supply Chain Management:</b> Offering
          end-to-end logistic solutions that enhance operational efficiency and
          drive business growth.
          <br />
          <br />
          Saharawinds Ltd logistic solutions are designed to meet the unique
          needs of each shipper, ensuring that shipper’s business can thrive in
          the global marketplace.
          <br />
          <br />{" "}
          <span className="orange">
            <b>Our Mission</b>
          </span>
          <br />
          At Saharawinds Ltd., our mission is to foster strategic partnership
          with shippers, revolutionize the logistics industry by providing
          innovative and reliable logistic solutions that optimize supply chain
          to drive growth.
          <br />
          {/* <br />
          <br />
          <div className="about-image-2"></div> */}
          {/* <br /> */}
          <br />
          <span className="orange">
            <b>Why Choose Saharawinds?</b>
          </span>
          <br />
          <b>Seamless Global Reach:</b> Saharawinds extensive network ensures
          shipments travel smoothly across borders from origin to destination,
          through our extensive freight forwarders network partners, we manage
          last mile logistics for export shipments as well as first mile
          logistics for import shipments. <br />
          <br />
          <b>Expert Customs Clearance:</b> Saharawinds experienced team
          navigates complex customs regulations with ease for both exports and
          import shipments.
          <br />
          <br /> <b>Optimized Supply Chain Solutions:</b> Saharawinds will
          streamline the supply chain, optimize costs and improving efficiency.
          <br />
          <br /> <b>Dedicated Customer Support:</b> Saharawinds dedicated team
          is always available to support shippers.
          <br />
          <br />
          <b>Cutting-Edge Technology:</b> Saharawinds leverage on technology to
          provide real-time visibility and control of shipments across different
          transport channels.
          <br />
          <br />
          <span className="orange">
            <b>Memberships</b>
          </span>
          <br />
          As a proud member of the Kenya International Freight Forwarders &
          Warehousing Association (KIFWA), we uphold industry standards and best
          practices, ensuring excellence in all our services.
        </p>
        <div className="grid grid-cols-1 gap-5">
          <div className="about-image rounded-md rounded-tr-3xl  hidden lg:block"></div>
          <div className="about-image-x rounded-md rounded-br-3xl hidden lg:block"></div>
          <div className="about-image-x rounded-md lg:rounded-br-3xl rounded-b-3xl h-[15rem]  block lg:hidden"></div>
        </div>
      </div>
      <div className="grid lg:grid-cols-2 grid-cols-1 gap-5 w-full mt-10  mx-[1rem] translate-x-[-1rem] outfit">
        {/* <div className="about-image-x w-full h-full"></div> */}
        {/* <div className="flex flex-col  gap-4"> */}
        <div
          className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl border-[color:var(--brand-primary)] border-[2px] w-full h-fit cursor-pointer"
          onClick={() => {
            if (q === 1) {
              return setQ(null);
            }
            return setQ(1);
          }}
        >
          <div className="flex justify-between gap-3 items-center">
            <span className="font-bold text-lg text-[color:var(--brand-primary)]">
              Core Logistics Services
            </span>
            <motion.div
              initial={{
                rotate: 180,
              }}
              animate={
                q === 1
                  ? {
                      rotate: 0,
                    }
                  : { rotate: 180, transition: { delay: 0.3 } }
              }
            >
              <KeyboardArrowUp className="text-[color:var(--brand-primary)]" />
            </motion.div>
          </div>
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={
              q !== 1
                ? {
                    height: 0,
                    opacity: 0,
                    transition: {
                      opacity: { delay: 0, duration: 0.3 },
                      height: {
                        delay: 0.3,
                        duration: 0.3,
                      },
                    },
                  }
                : {
                    height: "auto",
                    opacity: 1,
                    transition: {
                      height: { delay: 0, duration: 0.3 },
                      opacity: {
                        delay: 0.3,
                        duration: 0.3,
                      },
                    },
                  }
            }
            className="pointer-events-none"
          >
            <br />
            <span className="font-bold">International Freight Forwarding:</span>
            <br />
            ◦ Air freight
            <br />◦ Sea freight (both FCL and LCL)
            <br />◦ Multimodal transportation
            <br />
            <span className="font-bold">Customs Brokerage:</span>
            <br />
            ◦ Import and export clearance
            <br />
            ◦ Customs documentation and compliance
            <br />◦ Duty and tax optimization
          </motion.div>
        </div>
        <div
          className="bg-[color:var(--brand-primary-soft)] p-5 rounded-xl border-[color:var(--brand-primary)] border-[2px] w-full h-fit cursor-pointer"
          onClick={() => {
            if (q === 2) {
              return setQ(null);
            }
            return setQ(2);
          }}
        >
          <div className="flex justify-between items-center">
            <span className="font-bold  gap-3 text-lg text-[color:var(--brand-primary)]">
              Specialized Logistics Services
            </span>
            <motion.div
              initial={{
                rotate: 180,
              }}
              animate={
                q === 2
                  ? {
                      rotate: 0,
                    }
                  : { rotate: 180, transition: { delay: 0.3 } }
              }
            >
              <KeyboardArrowUp className="text-[color:var(--brand-primary)]" />
            </motion.div>
          </div>
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={
              q !== 2
                ? {
                    height: 0,
                    opacity: 0,
                    transition: {
                      opacity: { delay: 0, duration: 0.3 },
                      height: {
                        delay: 0.3,
                        duration: 0.3,
                      },
                    },
                  }
                : {
                    height: "auto",
                    opacity: 1,
                    transition: {
                      height: { delay: 0, duration: 0.3 },
                      opacity: {
                        delay: 0.3,
                        duration: 0.3,
                      },
                    },
                  }
            }
            className="pointer-events-none"
          >
            <br />
            <span className="font-bold">Cool chain logistics:</span>
            <br />
            ◦ Temperature-controlled transportation and storage
            <br />◦ Compliance with food safety and quality standards
            <br />
            <span className="font-bold">Project Logistics:</span>
            <br />◦ Handling of general cargo and complex large-scale projects,
            such as machinery, equipment, and raw materials <br />◦ Oversized
            and heavy lift cargo <br />◦ Project planning and execution <br />
            <span className="font-bold">Hazardous Goods Logistics:</span>
            <br />◦ Specialized handling, packaging, and transportation of
            hazardous materials
            <br />◦ Adherence to international regulations (e.g., IATA DGR, IMDG
            Code) <br />
            <span className="font-bold">E-commerce Logistics:</span>
            <br />◦ Fulfillment services <br />◦ First Mile pickup and Last-mile
            delivery <br />◦ Cross-border e-commerce
          </motion.div>
          {/* </div> */}
        </div>
      </div>
      <div className="grid lg:grid-cols-3 grid-cols-1 gap-4 w-full mt-10">
        <div className="service auto w-full">
          <div className="service-title">
            <h4 className="service-title-text full-center">
              Trade Compliance & Documentation
            </h4>
          </div>
          <div className="service-bold">
            Streamlining Documentation for Smooth, Compliant Trade
          </div>
          <p className="service-desc">
            Navigating regulatory requirements can be challenging. At Sahara
            Winds Ltd, we manage complex export and import documentation,
            ensuring all essential paperwork—such as certificates of origin,
            phytosanitary certificates, and tax declarations—is in order. From
            export declarations to import permits, we help ensure seamless,
            compliant cross-border transactions.
          </p>
        </div>
        <div className="service auto w-full">
          <div className="service-title">
            <h4 className="service-title-text full-center">
              Cold Chain Integrity Commitment
            </h4>
          </div>
          <div className="service-bold">Safeguarding Perishable Shipments</div>
          <p className="service-desc">
            Perishable goods demand a secure cold chain system to preserve
            quality. With refrigerated containers, temperature-controlled
            warehouses, and real-time monitoring tools like data loggers and
            RFID tags, we maintain optimal conditions for your cargo, ensuring
            it reaches its destination fresh and intact.
          </p>
        </div>
        <div className="service auto w-full">
          <div className="service-title">
            <h4 className="service-title-text full-center">
              Export and Import Customs Clearance
            </h4>
          </div>
          <div className="service-bold">
            Efficient Clearance for Seamless Trade
          </div>
          <p className="service-desc">
            Our skilled customs team helps you navigate evolving regulations to
            prevent delays and minimize storage fees. With a deep understanding
            of export and import procedures, we process essential paperwork
            directly with customs authorities to keep your cargo on schedule.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
